import { useStoredState } from "@/hooks/useStoredState";
import { ToolShell } from "@/components/tools/ToolShell";
import { AutoTextarea, TextField } from "@/components/tools/fields";
import { SubHead } from "@/components/tools/blocks";

const VISIT = [
  { k: "working", label: "What is working well?" },
  { k: "challenges", label: "Challenges identified?" },
  { k: "questions", label: "Questions arising?" },
  { k: "actions", label: "Actions recommended?" },
];
const QS = [
  "What proportion of pupils are on the SEND Register?",
  "What outcomes are being achieved?",
  "What are attendance trends?",
  "How many EHCPs are in place?",
  "What training has been delivered?",
  "How is parent voice gathered?",
  "What are the current SEND priorities?",
];

export const GovernorQuestions = () => {
  const [data, setData, reset] = useStoredState("governor-toolkit-v3", { visit: {}, answers: {}, notes: "" });
  const v = data.visit || {};
  const setV = (k, val) => setData((d) => ({ ...d, visit: { ...d.visit, [k]: val } }));
  return (
    <ToolShell id="governor-toolkit" onReset={reset} metaFields={false}>
      <SubHead letter="A" title="SEND Governor Visit Template" />
      <h5 className="mb-3 font-bold">Visit details</h5>
      <div className="grid gap-4 sm:grid-cols-2">
        <TextField id="gv-governor" label="Governor" value={v.governor} onChange={(x) => setV("governor", x)} testid="gv-governor" />
        <TextField id="gv-date" label="Date" type="date" value={v.date} onChange={(x) => setV("date", x)} testid="gv-date" />
        <TextField id="gv-staff" label="Staff met" value={v.staff} onChange={(x) => setV("staff", x)} testid="gv-staff" />
        <TextField id="gv-focus" label="Focus of visit" value={v.focus} onChange={(x) => setV("focus", x)} testid="gv-focus" />
      </div>
      <h5 className="mb-3 mt-6 font-bold">Evidence gathered</h5>
      <div className="grid gap-4 md:grid-cols-2">
        {VISIT.map((f) => <AutoTextarea key={f.k} id={`gv-${f.k}`} label={f.label} rows={3} value={v[f.k]} onChange={(x) => setV(f.k, x)} testid={`gv-${f.k}`} />)}
      </div>

      <SubHead letter="B" title="Questions Governors Should Ask" />
      <ol className="space-y-4">
        {QS.map((q, i) => (
          <li key={q} className="avoid-break rounded-2xl border-2 border-line bg-surface p-5" data-testid={`gq-${i}`}>
            <AutoTextarea id={`gq-${i}`} label={`${i + 1}. ${q}`} value={data.answers?.[i]} placeholder="Answer and evidence seen"
              onChange={(x) => setData((d) => ({ ...d, answers: { ...d.answers, [i]: x } }))} testid={`gq-${i}-answer`} />
          </li>
        ))}
      </ol>
      <div className="mt-6">
        <AutoTextarea id="gq-notes" label="Governors' notes" rows={4} value={data.notes} onChange={(x) => setData((d) => ({ ...d, notes: x }))} testid="gq-notes" />
      </div>
    </ToolShell>
  );
};
